import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const resenasData = [
  {
    nombre: "Adrián Rodríguez",
    texto: "El servicio de osteopatía de Raúl es inmejorable. Un gran profesional. Por mi actividad laboral y deportiva, sé bien lo que son las lesiones musculares, y Raúl es el que mejor me las ha tratado. Altamente recomendable.",
    estrellas: 5,
    fecha: "hace 11 meses"
  },
  {
    nombre: "Alexandra Valer",
    texto: "Lo recomiendo totalmente, la atención de Raúl personalizada y con tanta profesionalidad es estupenda! Me he realizado ya dos veces masajes y acupuntura y he notado un cambio total desde la primera vez.",
    estrellas: 5,
    fecha: "hace 1 año"
  },
  {
    nombre: "Carlos Mateos Boixader",
    texto: "Buen trato, Raúl aparte de un gran profesional es muy atento y un 10 en todos los aspectos, sin duda lo recomendaría como osteópata en Fuenlabrada.",
    estrellas: 5,
    fecha: "hace 1 año"
  },
  {
    nombre: "Sara Bravo",
    texto: "Un profesional en toda regla, hemos empezado hace 2 años a tratarnos con Raúl y puedo decir con certeza que es un excelente Osteópata.",
    estrellas: 5,
    fecha: "hace 1 año"
  },
  {
    nombre: "Miriam Montalvo",
    texto: "Fui a que me diera un masaje y el trato que tuve con Raúl fue impresionante. Me gustó mucho, iba por un dolor en el brazo y la verdad que genial, un gran profesional. Volveré.",
    estrellas: 5,
    fecha: "hace 1 año"
  },
  {
    nombre: "Gema García Monge",
    texto: "Cada vez que me trata Raúl salgo encantada. Sabe lo que hace como buen profesional que es. Lo recomiendo.",
    estrellas: 5,
    fecha: "hace 1 año"
  }
];

const TestimonialsSection = () => {
  return (
    <section id="testimonios" className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Star size={40} className="text-[var(--brand-dark)] fill-[var(--brand-primary)]" />
            <h2 className="heading-1">Lo que dicen mis pacientes</h2>
          </div>
          <p className="body-large max-w-2xl mx-auto mb-4">
            Opiniones reales de Google sobre mis tratamientos de osteopatía y masajes
          </p>
          <div className="flex items-center justify-center gap-2">
            <div className="flex">
              {[1,2,3,4,5].map((star) => (
                <Star key={star} size={24} className="text-yellow-400 fill-yellow-400" />
              ))}
            </div>
            <span className="body-medium font-semibold">5.0</span>
            <span className="body-small text-[var(--text-light)]">basado en reseñas de Google</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {resenasData.map((resena, index) => (
            <Card 
              key={index} 
              className="network-card relative"
              data-testid={`testimonio-${index}`}
            >
              <CardContent className="pt-6">
                <Quote 
                  size={32} 
                  className="absolute top-4 right-4 text-[var(--brand-primary)] opacity-50" 
                />
                
                <div className="flex mb-3">
                  {[...Array(resena.estrellas)].map((_, i) => (
                    <Star key={i} size={18} className="text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
                
                <p className="body-medium text-[var(--text-secondary)] mb-4 line-clamp-4">
                  "{resena.texto}"
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-[var(--border-light)]">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[var(--brand-primary)] flex items-center justify-center text-[var(--brand-dark)] font-bold">
                      {resena.nombre.charAt(0)}
                    </div>
                    <div>
                      <p className="body-small font-semibold">{resena.nombre}</p>
                      <p className="text-xs text-[var(--text-light)]">{resena.fecha}</p>
                    </div>
                  </div>
                  <img 
                    src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
                    alt="Google" 
                    className="h-5 opacity-60"
                  />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-8">
          <a 
            href="https://search.google.com/local/reviews?placeid=ChIJdWThCGyLQQ0REyTkNOdxLQI" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn-secondary inline-flex items-center gap-2"
            data-testid="ver-todas-resenas"
          >
            Ver todas las reseñas en Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
